export default __webpack_public_path__ + "static/media/logogoodwood404.ac321f84.png";